import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const setBodyMarginTop = () => {
	const appBar = document.getElementById('app-bar');
	if (appBar) {
		const appBarHeight = appBar.offsetHeight;
		document.body.style.marginTop = `${appBarHeight + 10}px`;
	}
};

window.addEventListener('load', setBodyMarginTop);
window.addEventListener('resize', setBodyMarginTop);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
